import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import Icon_module from "./Icon.module.js";
import { combineClasses } from "../utilities/combineClasses.js";
import { theme } from "../theme/index.js";
const ICON_SIZE_TO_PX = {
    'extra-small': '12px',
    small: '16px',
    normal: '24px',
    large: '32px'
};
const gridSize = 24;
const IconContainer = /*#__PURE__*/ forwardRef(({ children, size: _size = 'normal', rotation = 0, theme: _theme = 'default', themeVariant = 'normal', color, className = '', onClick, style, testId, ...props }, ref)=>{
    const size = ICON_SIZE_TO_PX[_size];
    return /*#__PURE__*/ jsx("svg", {
        width: size,
        height: size,
        viewBox: `0 0 ${gridSize} ${gridSize}`,
        className: combineClasses(Icon_module.icon, onClick && Icon_module.clickable, className),
        style: {
            '--icon--fill-and-stroke': theme.color[color] ?? color,
            ...style
        },
        onClick: onClick,
        "data-testid": testId,
        "data-theme": color ? void 0 : _theme,
        "data-variant": color ? void 0 : themeVariant,
        "aria-hidden": props['aria-label'] || props['aria-labelledby'] ? void 0 : true,
        ...props,
        ref: ref,
        children: /*#__PURE__*/ jsx("g", {
            transform: `rotate(${rotation} ${gridSize / 2} ${gridSize / 2})`,
            children: children
        })
    });
});
IconContainer.displayName = 'IconContainer';
const getSvgProps = ({ className, onClick, style, testId })=>({
        className,
        onClick,
        style,
        'data-test-id': testId
    });
const iconFactory = (displayName, children, defaultProps)=>{
    const IconComponent = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ jsx(IconContainer, {
            testId: displayName,
            ...defaultProps,
            ...props,
            className: combineClasses(defaultProps?.className, props.className),
            ref: ref,
            children: 'function' == typeof children ? children() : children
        }));
    IconComponent.displayName = displayName;
    return IconComponent;
};
export { ICON_SIZE_TO_PX, IconContainer, getSvgProps, iconFactory };
